import {useSuspenseQuery} from "@apollo/client";
import isEmpty from "lodash/isEmpty";

import {HorizontalDivider} from "@/components/HorizontalDivider.tsx";
import {GQL_CREDENTIAL_QUERY} from "@/lib/queries/credentials.ts";
import {ResponseStatus, ServerErrors} from "@/lib/types/common.ts";
import {CredentialResponse, Credentials} from "@/lib/types/credentials.ts";
import {CheckUsedInVaultItem} from "@/pages/vault/vaultForm/CheckUsedInVaultItem.tsx";

import {CredentialUpdateForm, UpdateCredentialFormValues} from "./CredentialUpdateForm.tsx";

interface CredentialUpdateBodyProps {
  credentialId?: string;
  onSubmit: (data: UpdateCredentialFormValues) => void;
  serverErrors?: ServerErrors;
  formId: string;
}

export const CredentialUpdateBody = ({credentialId, onSubmit, formId, serverErrors}: CredentialUpdateBodyProps) => {
  const {
    data: {response},
    error: queryError,
  } = useSuspenseQuery<CredentialResponse>(GQL_CREDENTIAL_QUERY, {
    variables: {
      id: credentialId,
    },
  });

  let credential: Credentials | undefined = undefined;
  let errorMessage: ServerErrors = serverErrors || {__all__: []};

  if (response.status === ResponseStatus.ERROR) {
    errorMessage = {...errorMessage, ...response?.message};
  } else {
    credential = response.data;
  }
  if (queryError || !isEmpty(errorMessage.non_field_errors)) {
    errorMessage.__all__.push("something went wrong please contact support");
  }

  return (
    <>
      {credential && (
        <>
          <CredentialUpdateForm
            serverErrors={errorMessage}
            credential={credential}
            formId={formId}
            onSubmit={onSubmit}
          />
          <HorizontalDivider className={"my-3"} />
          <CheckUsedInVaultItem credential={credential} />
        </>
      )}
    </>
  );
};
